import styled from 'styled-components';

export * from './styled.base';

export const TotalsContainer = styled.div`
  // account for 1rem margin on totals row
  padding: 0.375rem 2.125rem 1.375rem;
  margin-top: 1.5rem;
  font-family: ${Styles.fontFamily.base};
  border-bottom: 1px solid ${Styles.color.black};
`;
